import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import type { CourseContainerClientData } from '../../../typings/api/models';

export function getCoursesPreview(): Promise<CourseContainerClientData[]> {
    const { apiGetCoursesPreview } = apiConfig.getStaticUrls();

    return getFetch(apiGetCoursesPreview);
}
